import { render, staticRenderFns } from "./CurrentResidenceLength.vue?vue&type=template&id=02f40242&"
import script from "./CurrentResidenceLength.vue?vue&type=script&lang=js&"
export * from "./CurrentResidenceLength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports